import NoResults from '@/components/Elements/NoResults/NoResults';
import { Badge } from '@/components/ui/elements/badge';
import { InspectionCard } from '@/features/equipment/components/maintenance/inspections/InspectionCard';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { ShiftInspection } from '../hooks/useShiftData';

interface ShiftInspectionSectionProps {
  inspections: ShiftInspection[];
}

export const ShiftInspectionSection = ({ inspections }: ShiftInspectionSectionProps) => {
  const overdueCount = inspections.filter(
    (item) => item.inspection.is_past_due || item.inspection.has_failed,
  ).length;

  return (
    <section>
      <div className="flex items-center gap-2 mb-2">
        <WrenchScrewdriverIcon className="w-5 h-5 text-foreground/60" />
        <h3 className="text-sm font-semibold uppercase tracking-wide text-foreground/60">
          Inspections ({inspections.length})
        </h3>
        {overdueCount > 0 && (
          <Badge variant="red" size="sm">
            {overdueCount} overdue
          </Badge>
        )}
      </div>

      {inspections.length === 0 ? (
        <NoResults label="inspections" />
      ) : (
        <div className="space-y-2.5">
          {inspections.map((item) => (
            <div key={item.inspection.id}>
              <p className="text-xs font-semibold text-muted-foreground mb-1 uppercase tracking-wider">
                {item.equipmentLabel}
              </p>
              <InspectionCard inspection={item.inspection} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
